import { cleanString } from '../../../helpers/utils.js';
function applyDefaultFilter(currentDisplayValue, options) {
  var newOptions = options.filter(function (option) {
    var stringfiedOption = String(option.label);
    var stringfiedValue = String(currentDisplayValue);
    var cleanedOptionValue = cleanString(stringfiedOption);
    var cleanedValue = cleanString(stringfiedValue);
    return cleanedOptionValue.indexOf(cleanedValue) > -1;
  });
  return newOptions;
}
export { applyDefaultFilter };